<template>
  <section id="cotizacion">
    <div class="row" v-if="multimedia[0] != undefined">
      <div class="col-sm-12 cotitrack-fondo extranet-fondo-2">
        <div class="row">
          <div class="col-sm-6">
            <div class="cotitrack-contenido extranet-contenidor">
              <div>
                <h1>
                  <strong>{{ multimedia[0].title_multimedia }}</strong>
                </h1>
              </div>
              <span v-html="multimedia[0].desc_multimedia"></span>
              <br />
              <div class="cotitrack-texto">
                <a
                  id="confirm2"
                  :href="multimedia[0].link_button_multimedia"
                  target="_blank"
                  class="btn-al btn-al-lg btn-al-celeste"
                >
                  <strong>{{ multimedia[0].desc_button_multimedia }}</strong></a
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="cotitrack-contenido extranet-contenido">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="multimedia[0].link_multimedia"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getMultimediaInfo } from '@/service/multimedia.service.js';
import { config_settings } from '@/config.js';

export default {
  name: 'MultimediaModule',
  data() {
    return {
      multimedia: [],
    };
  },
  methods: {
    getMultimediaData() {
      getMultimediaInfo()
        .then((response) => {
          this.multimedia = response.data;
        })
        .catch((error) => {});
    },
  },
  created() {
    this.getMultimediaData();
  },
};
</script>
